<div *ngIf="profileUser?.type === 5" style="margin-top:-30px">
  <p-breadcrumb *ngIf="profileUser?.type === 5" class="max-w-full" [model]="breadcrumbMenuItems" [home]="breadcrumbHome"></p-breadcrumb>
</div>
<div *ngIf="profileUser?.type === 5" style="margin-top: 1em"></div>
  <div class="card" *ngIf="order">
    <div class="header-card">
      <div class="container-title">
        <h1 class="title-main">{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.PageTitle' | translate}}</h1>
      </div>

      <div class="flex flex-row gap-2" *ngIf="profile?.profileType == 'Importer'">
        <div class="flex"></div>
        <div class="flex justify-content-end gap-2">
          <div
            *ngIf="cancelPurchaseAvailable && order.importOrder.status == 2 &&  profile?.profileType == 'Importer' && !isClosedSale"
            class="flex base-btn cancel-purchase-btn text-btn"
            styleClass="p-button-outlined"
            pTooltip="Descartar compra"
            (click)="visibleCancelDialog = true"
          >
            {{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.CancelPurchaseButton' | translate}}
          </div>

          <div
            *ngIf="profile?.profileType == 'Importer' && order.importOrder.status == 2 && !isClosedSale"
            class="flex base-btn action-btn text-btn"
            pTooltip="Click aquí para verificar compra"
            (click)="confirmPurchase()"
          >
            {{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.ConfirmPurchaseButton' | translate}}
          </div>

          <div
            *ngIf="profile?.profileType == 'Importer' && (order.importOrder.status == 3 || order.importOrder.status == 4)"
            class="flex base-btn action-btn text-btn"
            (click)="goToPayments()"

          >
            <i class="pi pi-money-bill pr-2"></i>
            {{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.PaymentButton' | translate}}
          </div>
        </div>
      </div>

    </div>
    <div class="body-card">

      <div class="container-info mb-5">
        <div class="container-info-top">
          <div class="flex container-codes">
            <div class="cell-codes">
              <div class="containe-icon">
                <i class="pi pi-file"  style="color: #6da043;font-size:1.8em"></i>
              </div>
              <div class="section-text">
                <h4 class="label-codes">{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.OrderCodeText' | translate}}:</h4>
                <p class="text-codes">{{getOrderTitle()}}</p>
              </div>
            </div>
            <div class="cell-codes border-left">
              <div class="containe-icon">
                <i class="pi pi-calendar"  style="color: #6da043;font-size:1.8em"></i>
              </div>
              <div class="section-text">
                <h4 class="label-codes">{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.OrderDateText' | translate}}:</h4>
                <p class="text-codes">{{order.importOrder.created | date: 'dd-MM-yyyy'}}</p>
              </div>
            </div>
          </div>

          <div class="container-countries" *ngIf="isClosedSale==true">

            <div class="container-flex-between">
              <!-- <div class="flex justify-content-start align-items-center container-flex-full" *ngIf="order.importOrder.transportType==0 && order.delivery?.departurePort">
                <img [flag]="order.delivery?.departurePort?.country?.code" height="50px" alt=""/>
                <div class="flex flex-column" style="margin-left: 10px;">
                  <span style="font-weight: bolder; font-size: small;">{{order.delivery?.departurePort?.country | countryDescription}}</span>
                  <span style="font-size: small;">{{order.delivery?.departurePort?.name}}</span>
                </div>
              </div>
              <div class="flex justify-content-start align-items-center container-flex-full" *ngIf="order.importOrder.transportType==0 && !order.delivery?.departurePort">
                <img [flag]="order.importOrder.importFromCountry?.code" height="50px" alt=""/>
                <div class="flex flex-column" style="margin-left: 10px;">
                  <span style="font-weight: bolder; font-size: small;">{{order.importOrder.importFromCountry | countryDescription}}</span>
                </div>
              </div>

              <div class="flex justify-content-start align-items-center container-flex-full" *ngIf="order.importOrder.transportType==1 && order.delivery?.departureAirport != null  &&  order.delivery?.destinationAirport != undefined">
                <img [flag]="order.delivery?.departureAirport?.country?.code" height="50px" alt=""/>
                <div class="flex flex-column" style="margin-left: 10px;">
                  <span style="font-weight: bolder; font-size: small;">{{order.delivery?.departureAirport?.country | countryDescription}}</span>
                  <span style="font-size: small;">{{order.delivery?.departureAirport?.name}}</span>
                </div>
              </div>
              <div class="flex justify-content-start align-items-center container-flex-full" *ngIf="order.importOrder.transportType==1 && !order.delivery?.departureAirport">
                <img [flag]="order.importOrder.importFromCountry?.code" height="50px" alt=""/>
                <div class="flex flex-column" style="margin-left: 10px;">
                  <span style="font-weight: bolder; font-size: small;">{{order.importOrder.importFromCountry | countryDescription }}</span>
                </div>
              </div> -->

              <div class="flex justify-content-start">
                <app-location-info
                [type]="order.importOrder.transportType"
                [countryName]="order.delivery?.departurePort?.country?.name ?? order.importOrder.importFromCountry?.name"
                [countryCode]="order.delivery?.departurePort?.country?.code ?? order.importOrder.importFromCountry?.code"
                [portName]="order.delivery?.departurePort?.name ?? order.importOrder.portFrom?.name"
                [airportName]=" order.delivery?.departureAirport?.name ?? order.importOrder.fromAirport?.name"
                [cityName]="order.delivery?.departureCity?.name ?? order.importOrder.fromCity?.name"
                [showLocationName]="true"
                >
                </app-location-info>
              </div>

              <!-- <div class="flex flex-column justify-content-center">
                <div class="container-nave justify-content-center">
                  <span class="material-symbols-outlined" style="color: #6da043;" *ngIf="order.importOrder.transportType==0">directions_boat</span>
                  <span class="material-symbols-outlined" style="color: #6da043;" *ngIf="order.importOrder.transportType==1"> flight</span>
                  <span class="material-symbols-outlined" style="color: #6da043;">arrow_forward_ios</span>
                </div>
                <div *ngIf="order.delivery?.ship" class="flex justify-content-center">
                  <span class="text-center" style="font-size: small;">{{ order.delivery?.ship }}</span>
                </div>
              </div> -->
              <div class="flex justify-content-center">
                <app-transport-type-icon [type]="order.importOrder.transportType" [ship]="order.delivery?.ship">
                  </app-transport-type-icon>
              </div>


              <!-- <div class="flex justify-content-start align-items-center container-flex-full" *ngIf="order.importOrder.transportType==0 && order.delivery?.destinationPort">
                <img [flag]="order.delivery?.destinationPort?.country?.code" height="50px" alt=""/>
                <div class="flex flex-column" style="margin-left: 10px;">
                <span style="font-weight: bolder; font-size: small;">{{order.delivery?.destinationPort?.country | countryDescription}}</span>
                <span style="font-size: small;">{{order.delivery?.destinationPort?.name}}</span>
                </div>
              </div> -->

              <div class="flex justify-content-start">
                  <app-location-info
                  [type]="order.importOrder.transportType"
                  [countryName]="order.delivery?.destinationPort?.country?.name ?? order.importOrder.importToCountry?.name"
                  [countryCode]="order.delivery?.destinationPort?.country?.code ?? order.importOrder.importToCountry?.code"
                  [portName]="order.delivery?.destinationPort?.name ?? order.importOrder.portTo?.name"
                  [airportName]="order.delivery?.destinationAirport?.name ?? order.importOrder.destinationAirport?.name"
                  [cityName]="order.delivery?.destinationCity?.name ?? order.importOrder.destinationCity?.name"
                  [showLocationName]="true"
                  >
                  </app-location-info>
              </div>
            </div>

          </div>

          <div class="container-flex-fit">
            <div class="container-success" *ngIf="order.importOrder.status == 3 || order.importOrder.status == 4">
              <i class="pi pi-check-circle" style="color: #6da043;"></i>&nbsp;&nbsp;<span style="color: #6da043; line-height:1em">{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.OrderPurchaseConfirmText' | translate}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="container-columns-top" *ngIf="isClosedSale==true">

        <div class="flex-1"></div>

        <div class="column-top">
          <div class="row-info">
            <p class="label-info">{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.InfoDataDetail.ExportOrderDetailN' | translate}}:</p>
            <p class="p-info">
              {{order.genericDetails[0].sequence}}
            </p>
          </div>
          <div class="row-info">
            <p class="label-info">{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.InfoDataDetail.ExportOrderN' | translate}}:</p>
            <p class="p-info">{{getOrderTitle()}}</p>
          </div>
          <div class="row-info">
            <p class="label-info">{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.InfoDataDetail.ProgramID' | translate}}:</p>
            <p class="p-info">
              {{order.importOrder.directSaleProgramId ? order.importOrder.directSaleProgramId :  'N.A.'}}
            </p>
          </div>
        </div>

        <div class="flex-1"></div>
        <div class="border-dashed"></div>
        <div class="flex-1"></div>

        <div class="column-top">
          <div class="row-info">
            <p class="label-info">{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.InfoDataDetail.Importer' | translate}}:</p>
            <p class="p-info">
              {{order.importOrder.importer.companyName}}
            </p>
          </div>
          <div class="row-info">
            <p class="label-info">{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.InfoDataDetail.Exporter' | translate}}:</p>
            <p class="p-info">
              {{order.exportersInformation[0].companyName}}
            </p>
          </div>
          <div class="row-info">
            <p class="label-info">{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.InfoDataDetail.Pallets' | translate}}:</p>
            <p class="p-info">
              {{order.genericDetails[0].boxesPerPallet ? order.genericDetails[0].boxesPerPallet :  'N.A.'}}
            </p>
          </div>
        </div>

        <div class="flex-1"></div>
        <div class="border-dashed"></div>
        <div class="flex-1"></div>

        <div class="column-top">
          <div class="row-info">
            <p class="label-info">{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.InfoDataDetail.Container' | translate}}:</p>
            <p class="p-info">
              {{order.delivery?.containerNumber}}
            </p>
          </div>
          <div class="row-info">
            <p class="label-info">{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.InfoDataDetail.ETA' | translate}}:</p>
            <p class="p-info">
              {{order.delivery?.eta ? (order.delivery?.eta | date:'dd-MM-yyyy') : '(Pending)' }}
            </p>
          </div>
          <div class="row-info">
            <p class="label-info">{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.InfoDataDetail.ETD' | translate}}:</p>
            <p class="p-info">
              {{order.delivery?.etd ? (order.delivery?.etd | date:'dd-MM-yyyy') : '(Pending)' }}
            </p>
          </div>
        </div>

        <div class="flex-1"></div>
        <div class="border-dashed"></div>
        <div class="flex-1"></div>

        <div class="column-top">
          <div class="row-info">
            <p class="label-info">{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.InfoDataDetail.FridgeStorage' | translate}}:</p>
            <p class="p-info">
              {{order.genericDetails[0].fridgeStorageName}}
            </p>
          </div>
          <div class="row-info">
            <p class="label-info">{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.InfoDataDetail.FridgeStorageCity' | translate}}:</p>
            <p class="p-info">
              {{order.genericDetails[0].fridgeStorageCity}}
            </p>
          </div>
          <div class="row-info">
            <p class="label-info">{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.InfoDataDetail.FridgeStorageCountry' | translate}}:</p>
            <p class="p-info">
              {{order.genericDetails[0].fridgeStorageCountry}}
            </p>
          </div>
        </div>

        <div class="flex-1"></div>

      </div>



      <p-table
        [value]="details"
        responsiveLayout="stack"
        dataKey="rowexpansion"
        [breakpoint]="'600px'">
        <ng-template pTemplate="header">
          <tr>
            <th class="cell-header-table">
              <div class="cell-container">
                {{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.DetailOrderTable.ProductHeader' | translate}}
              </div>
            </th>
              <th class="cell-header-table" *ngIf="isClosedSale==false">
                <div class="cell-container">
                  {{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.DetailOrderTable.LocationHeader' | translate}}
                </div>
              </th>
            <th class="cell-header-table">
              <div class="cell-container">
                {{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.DetailOrderTable.ListPriceHeader' | translate}}
              </div>
            </th>
            <th class="cell-header-table">
              <div class="cell-container">
                {{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.DetailOrderTable.CasePerPalletsHeader' | translate}}
              </div>
            </th>
              <th class="cell-header-table" *ngIf="isClosedSale==false">
                <div class="cell-container">
                  {{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.DetailOrderTable.PalletsHeader' | translate}}
                </div>
              </th>
            <th class="cell-header-table">
              <div class="cell-container">
                Total cases
              </div>
            </th>
            <th class="cell-header-table" *ngIf="!isClosedSale">
              <div class="cell-container">
                {{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.DetailOrderTable.TotalPriceHeader' | translate}}
              </div>
            </th>
            <th class="cell-header-table" *ngIf="order.importOrder.status == 4">
              <div class="cell-container">
                Exporter
              </div>
            </th>
            <th class="cell-header-table">
              <div class="cell-container">
                {{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.DetailOrderTable.StatusHeader' | translate}}
              </div>
            </th>
            <th class="cell-header-table">
              <div class="cell-container">
                {{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.DetailOrderTable.ActionsHeader' | translate}}
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-detail let-expanded="expanded">
          <tr>
            <td class="cell-table">
              <div class="display-flex">
                <div class="figure-icon">
                  <img loading="lazy" [src]="detail.varietyUrlIcon | speciesImageUrl" style="border-radius: 7px; width: 100%; max-width: 60px; min-width: 60px; height: auto;" alt=""/>
                </div>
                <div class="container-text-offer">
                  <p class="text-table"><strong>{{getSpeciesName(detail)}}</strong></p>
                  <p class="text-table">{{detail.varietyName ? detail.varietyName : "N.A" }}</p>
                </div>
              </div>
            </td>

            <td class="cell-table" *ngIf="isClosedSale==false">
              <div class="container-text-offer">
                <p class="text-table">
                  {{ detail.fridgeStorageName ? detail.fridgeStorageName : 'N.A'}}
                </p>
                <p class="text-table">
                  {{ detail.fridgeStorageCity ? detail.fridgeStorageCity : 'N.A'}}
                </p>
                <p class="text-table">
                  {{ detail.fridgeStorageCountry ? detail.fridgeStorageCountry : 'N.A'}}
                </p>
              </div>
            </td>

            <td class="cell-table">
              <div *ngIf="!isClosedSale" class="container-text-center-offer">
                {{ detail.price | currency:'USD':'US$' }} {{detail.incoterms}}
              </div>
              <div *ngIf="isClosedSale" class="container-text-center-offer">
                <p-button
                class="p-button-sm"
                (onClick)="showCurrentPalletPriceModal(detail)"
                label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.ViewPricePalletButton' | translate}}"
                severity="secondary"
                icon="pi pi-eye"
                [disabled]="currentPrices.length < 1"

                [style]="{'font-size': 'small','line-height':'1.1em','padding':'.5em .7em'}"
                styleClass="p-button-outlined"
                >
                </p-button>
              </div>
            </td>

            <td class="cell-table">
              <div *ngIf="isClosedSale && currentPrices.length > 0" class="container-text-center-offer">
                  <p-button
                  class="p-button-sm"
                  (onClick)="showCurrentCasesModal(detail)"
                  label="{{'ImportCloseSaleTable.SeeCases' | translate}}"
                  severity="secondary"
                  icon="pi pi-eye"
                  [disabled]="currentPrices.length < 1"

                  [style]="{'font-size': 'small','line-height':'1.1em','padding':'.5em .7em'}"
                  styleClass="p-button-outlined"
                  >
                  </p-button>
              </div>
              <div *ngIf="!isClosedSale || currentPrices.length == 0"  class="container-text-center-offer">
                {{ detail.boxesPerPallet > 0 ? detail.boxesPerPallet : 'N.A.' }}
              </div>
            </td>

            <td class="cell-table" *ngIf="isClosedSale==false">
              <div class="container-text-center-offer">
                {{ detail.boxesPerPallet > 0 ? detail.palletsQuantity : 'N.A.'}}
              </div>
            </td>

            <td class="cell-table">
              <div *ngIf="isClosedSale && currentPrices.length > 0" class="container-text-center-offer">
                {{ getTotalPalletsConfiguration() }}
              </div>
              <div *ngIf="!isClosedSale || currentPrices.length == 0" class="container-text-center-offer">
                {{ getDetailTotalCases(detail) }}
              </div>
            </td>

            <td class="cell-table" *ngIf="!isClosedSale">
              <div class="container-text-center-offer">
                <span style="font-weight: bold; color: #8c2b87;">{{ getDetailTotalPrice(detail) | currency:'USD':'US$' }}</span>
              </div>
            </td>
            <td class="cell-table" *ngIf="order.importOrder.status == 4">
              <div  *ngIf="detail.exporter" class="flex justify-content-center align-items-center">
                <button pButton class="btn-exporter" Tooltip="Ver info"  (click)="viewExporterInfo(detail.exporter)">{{ detail.exporterCompanyName }}</button>
              </div>
              <div  *ngIf="!detail.exporter" class="flex justify-content-center align-items-center">
                <span>N.A</span>
              </div>
            </td>

              <td class="cell-table">
                <div class="flex justify-content-center align-items-center">
                  <div class="tag-pending" *ngIf="detail.status == 1" >{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.DetailOrderTable.StatusLabels.PendingExportLabel' | translate}}</div>
                  <div class="tag-pending" *ngIf="detail.status == 2" >{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.DetailOrderTable.StatusLabels.PendingQCLabel' | translate}}</div>
                  <div class="tag-verified" *ngIf="detail.status == 3" >{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.DetailOrderTable.StatusLabels.VerificationPartialLabel' | translate}}</div>
                  <div class="tag-verified" *ngIf="detail.status == 4" >{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.DetailOrderTable.StatusLabels.VerifiedLabel' | translate}}</div>
                </div>
              </td>


            <td class="cell-table">
              <div class="flex justify-content-center align-items-center">
                <div class="flex justify-content-start gap-2">
                  <p-button
                    pTooltip="{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.DetailOrderTable.VerifyPalletsButton' | translate}}"
                    tooltipPosition="bottom"
                    icon="pi pi-table"
                    *ngIf="detail.status === 1 && profile?.type == 1 && !order.importOrder.isFrozenFruit"
                    (onClick)="goToVerifyPalletsPage(detail)"
                    styleClass="p-button-outlined"
                    [style]="{'background-color': '#8c2b87', 'color': 'white','font-size': 'small','line-height':'1.1em','padding':'.5em .7em'}"
                    label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.VerifyPalletsButton2' | translate}}"
                  ></p-button>

                  <p-button
                    pTooltip="{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.DetailOrderTable.SeePalletsButton' | translate}}"
                    tooltipPosition="bottom"
                    icon="pi pi-table"
                    *ngIf="detail.status > 1 && profile?.type != 5 && !order.importOrder.isFrozenFruit"
                    (onClick)="goToVerifyPalletsPage(detail)"
                    [style]="{'background-color': '#8c2b87', 'color': 'white','font-size': 'small','line-height':'1.1em','padding':'.5em .7em'}"
                    styleClass="p-button-outlined"
                    label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.VerifyPalletsButton2' | translate}}"
                  ></p-button>

                  <p-button class="action-btn" pTooltip="{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.DetailOrderTable.VerifyPalletsButton' | translate}}" tooltipPosition="bottom" icon="pi pi-table" *ngIf="detail.status === 1 && profile?.type == 1 && order.importOrder.isFrozenFruit" (onClick)="goToFrozenFruitVerifyPalletsPage(detail)" styleClass="p-button-outlined"></p-button>
                  <p-button
                    *ngIf="detail.exportOfferId || this.order.importOrder.isFrozenFruit"
                    pTooltip="{{'UserPages.UserClosedSale.ImporterClosedSaleOrders.SeeExportOfferButton' | translate}}"
                    icon="pi pi-info-circle"
                    tooltipPosition="bottom"
                    (onClick)="viewExportOfferDetailDialog(detail)"
                    styleClass="p-button-outlined"
                    [style]="{'font-size': 'small','line-height':'1.1em','padding':'.5em .7em'}"
                    label="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.ViewOfferButton' | translate}}"
                  ></p-button>

                  <p-button  *ngIf="profile?.type == 5" pTooltip="{{ 'ForwarderPage.ForwarderReviewsPending.ButtonPreBL' | translate }}" icon="pi pi-table" (onClick)="goToDelivery(this.order.importOrder.guid)"></p-button>
                  <!-- <p-button *ngIf="profile?.type == 4" label="{{ 'ForwarderPage.ForwarderReviewsPending.ButtonReview' | translate }}" icon="pi pi-check-square" (onClick)="goToReviewDocuments(review)"></p-button> -->
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary" *ngIf="this.profile?.type == 2">
          <div class="flex align-items-center justify-content-end">
            <div *ngIf="!isClosedSale">
              {{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.TotalOrderText' | translate}}: <span style="font-weight: bold; color: #8c2b87;">
                {{ orderTotalPrice | currency:'USD':'US$' }}
              </span>
            </div>
          </div>
        </ng-template>
      </p-table>

      <div *ngIf="(order?.importOrder?.status == 4 || order?.importOrder?.isClosedSale) && delivery">
        <app-order-detail-tab
          [importOrder]="order.importOrder"
          [delivery]="delivery"
          [importOrderDetails]="order.genericDetails"
          [isClosedSale]="isClosedSale"
          [directSaleProgramId]="directSaleProgramId"
          [discounts]="discounts"
          [costs]="costs"
          [payments]="payments"
          [qualityControlDocuments]="order.qualityControlDocuments"
          [operationDocuments]="order.operationDocuments"
          [forwarderDocuments]="order.forwarderDocuments"
          [customAgentDocuments]="order.customAgentDocuments"
          [productCertificateDocuments]="order.productCertificateDocuments"
          [exportOfferDocuments]="order.exportOfferDocuments"
          [invoices]="order.invoices"
          [paymentsQualityControl]="order.paymentsQualityControl"
          *ngIf="delivery"
          >
        </app-order-detail-tab>
      </div>

  </div>
</div>



<p-dialog [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleExportOfferDialog" [style]="{width: '80%'}">
  <app-export-offer-detail [offer]="exportOffer" [productCertificateTypes]="selectedProductCertificateTypes" [packagingTypes]="selectedPackagingTypes" [importOrder]="order?.importOrder"></app-export-offer-detail>
  <app-frozen-fruit-export-offer-detail [offer]="frozenFruitExportOffer"></app-frozen-fruit-export-offer-detail>
  <ng-template pTemplate="footer">
    <p-button label="{{'UserPages.UserBargaining.OpenTab.BargainingDetail.AcceptNegotiationModal.CloseModalButton' | translate }}" (click)="visibleExportOfferDialog = false"></p-button>
  </ng-template>
</p-dialog>

<p-dialog header="{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.ExporterDetailsTitle' | translate}}" [resizable]="false" [modal]="true"  [draggable]="false" [(visible)]="visibleExporterDialog" [style]="{width: '80%'}">
  <app-exporter-info-modal [exporterInfo]="exporterShow">
  </app-exporter-info-modal>
  <ng-template pTemplate="footer">
    <p-button label="{{'UserPages.UserPurchaseOrders.PaymentsPage.OrderDetailPage.AcceptBtn' | translate}}" (click)="visibleExporterDialog = false"></p-button>
  </ng-template>
</p-dialog>

<p-dialog header="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.CurrentPricesHeader' | translate}}" [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleCurrentPalletsPrice" [style]="{width: '70vw'}">
  <p-table
  [value]="currentPrices"
  [paginator]="true"
  [rows]="10"
  [loading]="loading"
  responsiveLayout="stack"
  [breakpoint]="'600px'"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  >
  <ng-template pTemplate="header">
    <tr>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.SpeciesHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.VarietyHeader' | translate}}
      </th>
      <th *ngIf="visibleProducerColumn">
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.ProducerHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.CategoryHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.SpeciesSizeHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.NetKilosHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.BoxQuantityHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.PriceHeader' | translate}}
      </th>
    </tr>
  </ng-template>
  <ng-template  pTemplate="body" let-palletPrice>
    <tr>
      <td>
        {{palletPrice.species}}
      </td>
      <td>
        {{palletPrice.variety}}
      </td>
      <td  *ngIf="visibleProducerColumn">
        {{palletPrice.producer}}
      </td>
      <td>
        {{palletPrice.category}}
      </td>
      <td>
        {{palletPrice.speciesSize}}
      </td>
      <td>
        {{palletPrice.netKilos}}
      </td>
      <td>
        {{palletPrice.boxPerPallets}}
      </td>
      <td>
        {{palletPrice.price | currency: 'USD'}}
      </td>
    </tr>
  </ng-template>
  </p-table>
</p-dialog>

<p-dialog header="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.BoxesPerPalletsHeader' | translate}}" [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleCurrentPalletsCases" [style]="{width: '70vw'}">
  <p-table
  [value]="palletCases"
  [paginator]="true"
  [rows]="10"
  [loading]="loading"
  responsiveLayout="stack"
  [breakpoint]="'600px'"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  >
  <ng-template pTemplate="header">
    <tr>
      <th  style="text-align: center;">
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.SpeciesHeader' | translate}}
      </th>
      <th  style="text-align: center;">
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.VarietyHeader' | translate}}
      </th>
      <th  style="text-align: center;">
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.SpeciesSizeHeader' | translate}}
      </th>
      <th  style="text-align: center;">
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.PalletsHeader' | translate}}
      </th>
      <th  style="text-align: center;">
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.BoxQuantityHeader' | translate}}
      </th>
    </tr>
  </ng-template>
  <ng-template  pTemplate="body" let-palletPrice>
    <tr>
      <td style="text-align: center;">
        {{palletPrice.speciesName}}
      </td>
      <td style="text-align: center;">
        {{palletPrice.varietyName}}
      </td>
      <td style="text-align: center;">
        {{palletPrice.speciesSize}}
      </td>
      <td style="text-align: center;">
        {{palletPrice.pallets}}
      </td>
      <td style="text-align: center;">
        {{palletPrice.boxesPerPallets}}
      </td>
    </tr>
  </ng-template>
    <ng-template pTemplate="footer">
    <tr>
      <td  style="text-align: center;">Total:</td>
      <td colspan="2" ></td>
      <td  style="text-align: center;">{{ getTotalPallets()  }}</td>
      <td  style="text-align: center;">{{ getTotalCases()  }}</td>
    </tr>
  </ng-template>
  </p-table>
</p-dialog>

<p-dialog header="{{'CancelPurchaseModal.Header' | translate}}" [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleCancelDialog" [style]="{width: '500px'}">
  <div class="grid">
    <div class="col-12">
      <p style="text-align: center;">{{'CancelPurchaseModal.ConfirmMessage' | translate}}</p>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-between">
      <p-button label="{{'CancelPurchaseModal.CancelButton' | translate}}" (onClick)="visibleCancelDialog = false" [loading]="loading" styleClass="p-button-outlined"></p-button>
      <p-button label="{{'CancelPurchaseModal.ConfirmButton' | translate}}" (onClick)="cancelPurchaseOrder()" [loading]="loading"></p-button>
    </div>
  </ng-template>
</p-dialog>
